import { removeItem, setItem } from '../../helpers/webStorage';

enum SSKeys {
  QueryString = 'query-string',
  ProductLinks = 'product-links',
  BackToResults = 'back-to-results-link',
  LastViewedProduct = 'last-viewed-product',
  CurrentProduct = 'current-product'
}

function computeCurrentQueryString(): string {
  if (!window.globalLister) return '';
  const urlSearchParams = new URLSearchParams(window.location.search);
  const { listerData } = window.globalLister;
  const category = listerData.categoryCode;
  if (category) {
    urlSearchParams.set('category', category);
  }
  return urlSearchParams.toString();
}

function setSSQueryKey(ssQueryValue?: string): void {
  setItem(SSKeys.QueryString, ssQueryValue ?? computeCurrentQueryString());
  removeItem(SSKeys.ProductLinks);
  setItem(SSKeys.BackToResults, window.location.href);
}

export { SSKeys, setSSQueryKey };
